/**
 * RealTimeTrainingProgress utility functions
 */

/**
 * Format seconds to human-readable time string
 */
export const formatTime = (seconds: number): string => {
  if (seconds < 60) return `${Math.round(seconds)}s`;
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ${Math.round(seconds % 60)}s`;
  return `${Math.floor(seconds / 3600)}h ${Math.floor((seconds % 3600) / 60)}m`;
};

/**
 * Post-training step translation keys
 */
const POST_TRAINING_STEP_KEYS: Record<string, string> = {
  'evaluating': 'postTraining.steps.evaluating',
  'preparing_save': 'postTraining.steps.preparing_save',
  'uploading_results': 'postTraining.steps.uploading_results',
  'preparing_upload': 'postTraining.steps.preparing_upload',
  'compressing': 'postTraining.steps.compressing',
  'compression_done': 'postTraining.steps.compression_done',
  'uploading': 'postTraining.steps.uploading',
  'upload_complete': 'postTraining.steps.upload_complete',
  'results_uploaded': 'postTraining.steps.results_uploaded',
  'database_saved': 'postTraining.steps.database_saved',
  'saving_plots': 'postTraining.steps.saving_plots',
  'uploading_models': 'postTraining.steps.uploading_models',
  'models_uploaded': 'postTraining.steps.models_uploaded'
};

/**
 * Get human-readable label for post-training step using i18n
 */
export const getPostTrainingStepLabel = (
  step: string,
  t: (key: string, options?: { defaultValue?: string }) => string
): string => {
  const key = POST_TRAINING_STEP_KEYS[step];
  if (key) {
    return t(key, { defaultValue: step });
  }
  return step;
};
